<template>
  <div v-if="animal">
    <v-card flat color="transparent" class="mt-7">
      <v-toolbar class="bdr secondary2light" :elevation="0" outlined>
        <v-toolbar-title
          class="grey--text text--darken-2"
          style="font-size: 18px"
          >{{ $t("animal.reproduction") }}</v-toolbar-title
        >
      </v-toolbar>
    </v-card>

    <v-card flat class="mt-7" v-if="!showEdit">
      <v-card-text>
        <v-tabs class="tabs-pill" v-model="tab">
          <v-tab class="text-capitalize text-left">{{
            $t("animal.reproductionInfo.fertility")
          }}</v-tab>
          <v-tab class="text-capitalize" v-if="animal.gender == 'Female'">{{
            $t("animal.reproductionInfo.progeny")
          }}</v-tab>
          <!-- <v-tab class="text-capitalize" v-if="isAnimalForSlaughter">{{
            $t("animal.performanceInfo.meatQuality")
          }}</v-tab> -->
        </v-tabs>
        <v-tabs-items v-model="tab" class="mt-5">
          <v-tab-item>
            <Male :milk="performance" v-if="animal.gender == 'Male'" />
            <Female :milk="performance" v-if="animal.gender == 'Female'" />
          </v-tab-item>
          <v-tab-item v-if="animal.gender == 'Female'">
            <Progeny :animalWeight="performance" />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>

    <PerformanceEdit
      @performance:close="showEdit = false"
      @performance:updated="onPerformanceUpdate"
      v-else
      :_performance="performance"
    />
    <prompt-dialog
      @closeDialog="showPromptDialog = false"
      @saveData="saveFormData"
      :dialogI="showPromptDialog"
      v-if="showPromptDialog"
    />
  </div>
</template>

<script>
import Progeny from "./reproduction/progeny/Progeny.vue";
import Male from "./reproduction/fertility/Male.vue";
import Female from "./reproduction/fertility/Female.vue";
import PerformanceEdit from "./performance/PerformanceEdit.vue";
import PromptDialog from "../common/PromptDialog.vue";

import { generalInfo } from "@/graphql/Animals.gql";
import { performance } from "@/graphql/Performance.gql";

export default {
  apollo: {
    animal: {
      query: generalInfo,
      variables() {
        return {
          id: parseInt(this.$route.params.animal_number),
        };
      },
      fetchPolicy: "network-only",
      update: (data) => data.generalInformation,
    },
    performance: {
      query: performance,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
    },
  },

  components: {
    "prompt-dialog": PromptDialog,
    Progeny,
    Male,
    Female,
    PerformanceEdit,
  },
  beforeRouteLeave(to, from, next) {
    if (this.promptNextRoute) {
      next();
    } else {
      if (this.hasChanged && this.showEdit) {
        this.promptToRoute = to;
        this.showPromptDialog = true;
      } else {
        next();
      }
    }
  },
  computed: {
    hasChanged() {
      return true;
    },

    isAnimalForSlaughter() {
      console.log(this.animal);
      return (
        this.animal &&
        this.animal.removalInformation &&
        this.animal.removalInformation.reasonForRemoval &&
        this.animal.removalInformation.reasonForRemoval.toLowerCase() ==
          "slaughtered"
      );
    },
  },

  data() {
    return {
      milk: {},
      performance: {},
      showEdit: false,
      tab: null,
      showPromptDialog: false,
      promptToRoute: null,
      promptNextRoute: false,
      defaultData: {},
    };
  },

  methods: {
    saveFormData(answer) {
      this.showPromptDialog = false;
      if (!answer) {
        this.promptNextRoute = true;
        this.$router.push(this.promptToRoute);
      }
    },
    onPerformanceUpdate() {
      this.$apollo.queries.performance.refetch();
      this.showEdit = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}
</style>
